import { useEffect } from 'react';
import UbicacionForm from '../../components/ubicaciones/UbicacionForm';
import {
  useUbicacionesStore,
  type RegistrarUbicacion
} from '../../stores/ubicaciones/ubicaciones.store';

const AgregarUbicacion = () => {
  const { current: ubicacion, nuevo, registrar } = useUbicacionesStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarUbicacion) => {
    return registrar(values);
  };

  return <UbicacionForm esAgregar={true} ubicacion={ubicacion} onSave={handleSave} />;
};

export default AgregarUbicacion;
